import { IconButton, Tooltip } from '@mui/material';
import React, { Fragment, isValidElement } from 'react';
import { SecuredIconButton, SecuredSection } from '../../auth/Security';
import { SIZES } from '../../constants/constants';
import type { SecuredActionType } from '../ActionType';
import { useSecuredActionsWithSecurityTargets } from '../hooks/useSecuredActionsWithSecurityTargets';

export interface EditablePanelActionsProps {
    securedActions?: SecuredActionType[];
}

export default function EditablePanelActions({ securedActions = [] }: EditablePanelActionsProps) {
    const securedActionsWithTargets = useSecuredActionsWithSecurityTargets(securedActions);

    return securedActionsWithTargets.map(({ action, securityTarget }, index: number) => (
        <Fragment key={index}>
            {action.component ? (
                action.securityAction ? (
                    <SecuredSection
                        securityAction={action.securityAction}
                        securityTarget={securityTarget}
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        {isValidElement(action.component)
                            ? action.component
                            : typeof action.component === 'function'
                              ? action.component()
                              : null}
                    </SecuredSection>
                ) : isValidElement(action.component) ? (
                    action.component
                ) : typeof action.component === 'function' ? (
                    action.component()
                ) : null
            ) : (
                <Tooltip title={action?.tooltip || ''}>
                    {action.securityAction ? (
                        <SecuredIconButton
                            aria-label={typeof action.label === 'string' ? action.label : undefined}
                            data-testid={action.dataTestId}
                            securityAction={action.securityAction}
                            securityTarget={securityTarget}
                            size={SIZES.small}
                            onClick={action.onClick}
                            disabled={action.disabled}
                            sx={{ display: action.hidden ? 'none' : undefined }}
                        >
                            {action.icon && <action.icon fontSize={SIZES.small} />}
                        </SecuredIconButton>
                    ) : (
                        <IconButton
                            aria-label={typeof action.label === 'string' ? action.label : undefined}
                            data-testid={action.dataTestId}
                            size={SIZES.small}
                            onClick={action.onClick}
                            disabled={action.disabled}
                            sx={{ display: action.hidden ? 'none' : undefined }}
                        >
                            {action.icon && <action.icon fontSize={SIZES.small} />}
                        </IconButton>
                    )}
                </Tooltip>
            )}
        </Fragment>
    ));
}
